/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OnlineInputs */

const en_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const es_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En línea`)
};

const fr_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ligne`)
};

const de_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const ja_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンライン`)
};

const zh_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线`)
};

const ar_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متصل`)
};

const id_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const it_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const ru_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В сети`)
};

const pt_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const ko_online = /** @type {(inputs: OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`온라인`)
};

/**
* | output |
* | --- |
* | "Online" |
*
* @param {OnlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const online = /** @type {((inputs?: OnlineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OnlineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_online(inputs)
	if (locale === "es") return es_online(inputs)
	if (locale === "fr") return fr_online(inputs)
	if (locale === "de") return de_online(inputs)
	if (locale === "ja") return ja_online(inputs)
	if (locale === "zh") return zh_online(inputs)
	if (locale === "ar") return ar_online(inputs)
	if (locale === "id") return id_online(inputs)
	if (locale === "it") return it_online(inputs)
	if (locale === "ru") return ru_online(inputs)
	if (locale === "pt") return pt_online(inputs)
	return ko_online(inputs)
});